import { groupOptions, optionLabel, activeAiGroups } from '../squads/classroom/aiGroups';
import { PortfolioEntry } from '../squads/classroom/types';
import { LibraryItem } from './types';

/** Keep every uploaded video option, in shot order, in the nominated collection. */
export function shotBatchForNomination(entry: PortfolioEntry): NonNullable<LibraryItem['shotBatch']> {
  const shots = activeAiGroups(entry).filter(group => group.kind === 'shot');
  if (!shots.length) throw new Error('Add shots before nominating a shot batch.');
  const videos = shots.flatMap(shot => {
    const options = groupOptions(entry, shot.id).filter(option => option.type === 'video' && option.url);
    if (!options.length) throw new Error(`Upload a video for ${shot.title} before nominating the full batch.`);
    return options.map((option, index) => ({
      id: option.id, url: option.url!, title: `${shot.title}${options.length > 1 ? ` · Option ${optionLabel(index)}` : ''}`,
      ...(option.posterUrl ? { posterUrl: option.posterUrl } : {}),
    }));
  });
  return { videos };
}
